/* ============================================================
   SS HELP WIDGET — behavior (round 7, 2026-07-18)
   File: assets/ss-help.js — loaded deferred by snippets/ss-help-widget.liquid.
   Ported from Gyaanstore's gs-help-widget.js, adapted:
   - No portal needed: theme.liquid renders the widget as a direct
     child of <body> (position:fixed is already viewport-true).
   - Sticky-aware lift measures THIS theme's bottom bars:
     .ss-sticky (PDP ATC bar) and .ss-ctabar (cart page CTA).
   - Open/close with scroll lock, Esc + scrim close, focus trap,
     focus return to the opener.
   ============================================================ */
(function () {
  'use strict';

  function barHeight() {
    var els = document.querySelectorAll('.ss-sticky, .ss-ctabar');
    var h = 0;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || r.height === 0) return;
      /* only fixed bars actually occupying the bottom edge count */
      if (r.bottom >= window.innerHeight - 4 && r.top < window.innerHeight) {
        h = Math.max(h, Math.round(window.innerHeight - r.top));
      }
    });
    return h;
  }

  function init(root) {
    if (root.dataset.ssHelpInit === '1') return;
    root.dataset.ssHelpInit = '1';

    var btn = root.querySelector('[data-ss-help-btn]');
    var sheet = root.querySelector('[data-ss-help-sheet]');
    var box = root.querySelector('[data-ss-help-box]');
    if (!btn || !sheet || !box) return;

    var lastFocus = null;

    /* keep the button above whichever sticky bottom bar is visible */
    var ticking = false;
    function place() {
      ticking = false;
      var h = barHeight();
      root.style.setProperty('--ss-help-pos', (h ? h + 12 : 16) + 'px');
    }
    function onMove() {
      if (!ticking) { ticking = true; requestAnimationFrame(place); }
    }
    window.addEventListener('scroll', onMove, { passive: true });
    window.addEventListener('resize', onMove);
    place();
    window.addEventListener('load', function () { setTimeout(place, 600); });

    function focusables() {
      return box.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    }

    function open() {
      lastFocus = document.activeElement;
      sheet.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('ss-help-open');
      box.focus();
    }

    function close() {
      sheet.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('ss-help-open');
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus(); else btn.focus();
    }

    btn.addEventListener('click', function () { sheet.hidden ? open() : close(); });
    root.querySelectorAll('[data-ss-help-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === box)) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ss-help]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
